<template>
  <div class="qrcode">
    <img :src="currentImg" :alt="$t('nav.qrcode')" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentImg: require("@/assets/qrcode.png"),
    }
  },
}
</script>

<style lang="less" scoped>
.qrcode {
  width: 62.5vw; /* 1200px at 1920px */
  height: 37.5vw; /* 720px at 1920px */
  margin-top: 4.53vw; /* 87px at 1920px */
  padding: 1.56vw 0; /* 30px at 1920px */
  img {
    width: 17.19vw; /* 330px at 1920px */
    height: 34.38vw; /* 660px at 1920px */
  }
}
</style>
